module.exports = __webpack_public_path__ + "img/PAAB.8901ce85.jpg";